import {Divider, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
import FTMDTabs from './FTMDTabs';

const {Paragraph} = Typography;
const Content = Layout;

const FTMD = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Fundamentals and troubleshooting</Paragraph>
      </Content>
      <FTMDTabs/>
      <Divider/>
    </Layout>
  );
};

export default FTMD;
